"use strict";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PaginatedItems = void 0;

var _react = _interopRequireWildcard(require("react"));

var _baseui = require("baseui");

var _button = require("baseui/button");

var _table = require("baseui/table");

var _pagination = require("baseui/pagination");

var _propTypes = require("prop-types");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var BaseButton = {
  style: function style(_ref) {
    var $theme = _ref.$theme;
    return {
      color: $theme.colors.mono600,
      fontWeight: 'bold',
      ':hover': {
        backgroundColor: 'transparent',
        color: $theme.colors.mono200
      },
      ':focus': {
        backgroundColor: 'transparent',
        color: $theme.colors.mono200
      },
      ':active': {
        backgroundColor: 'transparent',
        color: $theme.colors.mono200
      },
      ':disabled': {
        cursor: 'not-allowed',
        backgroundColor: 'transparent',
        color: $theme.colors.buttonDisabledText
      }
    };
  }
};
var PaginationContainer = (0, _baseui.styled)('div', function (_ref2) {
  var $theme = _ref2.$theme;
  var sizing = $theme.sizing;
  return {
    paddingTop: sizing.scale600,
    paddingBottom: sizing.scale600,
    display: 'flex'
  };
});
var NextButton = {
  component: function component(_ref3) {
    var onClick = _ref3.onClick;
    return _react["default"].createElement(_button.Button, {
      kind: _button.KIND.minimal,
      onClick: onClick,
      overrides: {
        BaseButton: BaseButton
      }
    }, ">");
  }
};
var PrevButton = {
  component: function component(_ref4) {
    var onClick = _ref4.onClick;
    return _react["default"].createElement(_button.Button, {
      kind: _button.KIND.minimal,
      onClick: onClick,
      overrides: {
        BaseButton: BaseButton
      }
    }, "<");
  }
};
var MaxLabel = {
  style: function style(_ref5) {
    var $theme = _ref5.$theme;
    return {
      backgroundColor: 'transparent',
      color: $theme.colors.mono600
    };
  }
};
var DropdownContainer = {
  style: function style(_ref6) {
    var $theme = _ref6.$theme;
    return {
      backgroundColor: $theme.colors.mono200
    };
  }
};
var StyledHeadlessTable = (0, _baseui.withStyle)(_table.StyledTable, function (_ref7) {
  var $theme = _ref7.$theme;
  return {
    backgroundColor: 'transparent',
    marginTop: $theme.sizing.scale400
  };
});
var StyledTableCell = (0, _baseui.withStyle)(_table.StyledCell, {
  paddingTop: 0,
  paddingBottom: 0,
  paddingLeft: 0,
  paddingRight: 0
}); // https://baseweb.design/components/table/

var PaginatedItems = function PaginatedItems(_ref8) {
  var data = _ref8.data,
      pageSize = _ref8.pageSize,
      renderer = _ref8.renderer;

  var _useState = (0, _react.useState)(1),
      _useState2 = _slicedToArray(_useState, 2),
      page = _useState2[0],
      setPage = _useState2[1];

  var handlePageChange = function handlePageChange(nextPage) {
    if (nextPage < 1) {
      return;
    }

    if (nextPage > Math.ceil(data.length / pageSize)) {
      return;
    }

    setPage(nextPage);
  };

  var view = function view() {
    var min = (page - 1) * pageSize;
    var sliced = data.slice(min, min + pageSize);
    return sliced.map(function (row, index) {
      return _react["default"].createElement(_table.StyledRow, {
        key: index
      }, _react["default"].createElement(StyledTableCell, null, renderer(row)));
    });
  };

  return _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement("div", null, _react["default"].createElement(StyledHeadlessTable, null, _react["default"].createElement(_table.StyledBody, {
    $width: "100%"
  }, view()))), data.length > pageSize && _react["default"].createElement(PaginationContainer, null, _react["default"].createElement(_pagination.Pagination, {
    currentPage: page,
    numPages: Math.ceil(data.length / pageSize),
    onPageChange: function onPageChange(_ref9) {
      var nextPage = _ref9.nextPage;
      return handlePageChange(nextPage);
    },
    overrides: {
      NextButton: NextButton,
      PrevButton: PrevButton,
      MaxLabel: MaxLabel,
      DropdownContainer: DropdownContainer
    }
  })));
};

exports.PaginatedItems = PaginatedItems;
PaginatedItems.propTypes = {
  data: (0, _propTypes.arrayOf)(_propTypes.shape).isRequired,
  pageSize: _propTypes.number.isRequired,
  renderer: (0, _propTypes.oneOfType)([_propTypes.node, _propTypes.func]).isRequired
};